// 3스텝 슬라이드 설문 폼
// 스텝1: 임플란트는 누구를 위해 알아보고 계시나요? (본인/가족 혹은 지인)
// 스텝2: 성함과 연락처 입력
// 스텝3: 개인정보 동의 및 제출

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { prohibitedWords } from "../utils/dummyData";

import "./randingStyle27.scss";
import PrivacyContent from "./PrivacyContent";
import MarketingContent from "./MarketingContent";

function RandingStyle27({
  urlCode,
  urlCodeSettingId,
  imageFolderPath,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  apiUrl,
  privacyMessage,
  kakaotalk,
  carrotTag,
  customFooter,
  footerData,
  imageExtension = "jpg",
  imageAltTexts,
  stepImages,
  selectOptions = ["본인", "가족 혹은 지인"],
  legacyMarketing = false,
  privacyDetailContent,
  showMarketing = true,
}) {
  const navigate = useNavigate();
  const privacyName = privacyCompanyName || companyName || "수집주체명";

  // 상태 관리
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedFor, setSelectedFor] = useState(""); // 본인/가족 선택
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [isMarketingModal, setIsMarketingModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
    setIsMarketingModal(false);
  };

  const toggleMarketingModal = () => {
    setIsMarketingModal(!isMarketingModal);
    setIsPrivacyPolicyModal(false);
  };

  const handleAllAgree = () => {
    const newValue = !(isAgreed && isMarketingAgreed);
    setIsAgreed(newValue);
    setIsMarketingAgreed(newValue);
  };

  const handleSelectFor = (value) => {
    setSelectedFor(value);
    setCurrentStep(2);
  };

  const nextStep = () => {
    if (currentStep === 2) {
      // Step 2에서 이름과 연락처 검증
      if (!name.trim()) {
        alert("이름을 입력해주세요.");
        return;
      }
      const fullPhone = `${phoneNumber.first}${phoneNumber.second}${phoneNumber.third}`;
      if (fullPhone.length < 10) {
        alert("연락처를 정확히 입력해주세요.");
        return;
      }
    }
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleSubmit = () => {
    const selectedOption = selectedFor;

    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  // 이미지 경로 생성 헬퍼
  const getImagePath = (imageNum) => {
    if (stepImages) {
      if (imageNum === "01") return stepImages.step1;
      if (imageNum === "02") return stepImages.step2;
      if (imageNum === "03") return stepImages.step3;
    }
    return `${imageFolderPath}/${imageNum}.${imageExtension}`;
  };

  return (
    <div className="form-container randing-style-27">
      {/* 스텝 1 - 본인/가족 선택 */}
      {currentStep === 1 && (
        <div className="step step1">
          <div className="step-content">
            <div className={`select-buttons ${selectOptions.length > 2 ? "grid-layout" : ""}`}>
              {selectOptions.map((option) => (
                <button
                  key={option}
                  className={`select-btn ${selectedFor === option ? "selected" : ""}`}
                  onClick={() => handleSelectFor(option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
          <div className="step-image-wrapper">
            <img src={getImagePath("01")} alt={imageAltTexts?.step1 || "임플란트 상담"} />
          </div>
        </div>
      )}

      {/* 스텝 2 - 이름/연락처 입력 */}
      {currentStep === 2 && (
        <div className="step step2">
          <div className="step-content">
            <div className="input-form">
              <div className="input-field">
                <input
                  type="text"
                  placeholder="이름"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="input-field">
                <input
                  type="tel"
                  placeholder="휴대폰 번호('-'제외)"
                  value={
                    phoneNumber.first
                      ? `${phoneNumber.first}${phoneNumber.second ? `-${phoneNumber.second}` : ""}${phoneNumber.third ? `-${phoneNumber.third}` : ""}`
                      : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    if (value.length <= 11) {
                      const first = value.substring(0, 3);
                      const second = value.substring(3, 7);
                      const third = value.substring(7, 11);
                      setPhoneNumber({ first, second, third });
                    }
                  }}
                  maxLength="13"
                />
              </div>
              <button
                className="continue-btn"
                onClick={nextStep}
                style={{
                  width: '100%',
                  padding: '15px',
                  backgroundColor: '#0066FF',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  marginTop: '15px'
                }}
              >
                계속하기
              </button>
            </div>
          </div>
          <div className="step-image-wrapper">
            <img src={getImagePath("02")} alt={imageAltTexts?.step2 || "정보 입력"} />
          </div>
        </div>
      )}

      {/* 스텝 3 - 개인정보 동의 및 제출 */}
      {currentStep === 3 && (
        <div className="step step3">
          <div className="step-content">
            <div className="agreement-section">
              <div className="agree-item all-agree">
                <input
                  type="checkbox"
                  id="allAgree"
                  checked={isAgreed && isMarketingAgreed}
                  onChange={handleAllAgree}
                />
                <label htmlFor="allAgree">전체 동의</label>
              </div>

              <div className="agree-item-wrapper">
                <div className="agree-item">
                  <input
                    type="checkbox"
                    id="privacyPolicyAgree"
                    checked={isAgreed}
                    onChange={() => setIsAgreed(!isAgreed)}
                  />
                  <label htmlFor="privacyPolicyAgree">
                    상담/예약 서비스 제공 동의 (필수)
                  </label>
                  <span className="detail-link" onClick={togglePrivacyPolicyModal}>
                    ({isPrivacyPolicyModal ? "닫기" : "자세히보기"})
                  </span>
                </div>
                <div className={`toggle-content ${isPrivacyPolicyModal ? "open" : ""}`}>
                  <div className="toggle-content-inner">
                    {privacyDetailContent || <PrivacyContent companyName={privacyName} />}
                  </div>
                </div>
              </div>
{showMarketing && (
              <div className="agree-item-wrapper">
                <div className="agree-item">
                  <input
                    type="checkbox"
                    id="marketingAgree"
                    checked={isMarketingAgreed}
                    onChange={() => setIsMarketingAgreed(!isMarketingAgreed)}
                  />
                  <label htmlFor="marketingAgree">
                    마케팅 정보 수신 (선택)
                  </label>
                  <span className="detail-link" onClick={toggleMarketingModal}>
                    ({isMarketingModal ? "닫기" : "자세히보기"})
                  </span>
                </div>
                <div className={`toggle-content ${isMarketingModal ? "open" : ""}`}>
                  <div className="toggle-content-inner">
                    <MarketingContent companyName={privacyName} legacy={legacyMarketing} />
                  </div>
                </div>
              </div>
)}
              <p className="benefitInfo">
                ※ 상담/예약 서비스 제공 동의는 필수 항목입니다.
                {showMarketing && (
                  <>
                <br />
                ※ 마케팅 정보 수신은 선택 항목이며, 동의하지 않아도 신청할 수 있습니다.
                 </>
                 )}
              </p>

              <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                설문제출완료
              </button>
            </div>

          </div>
          <div className="step-image-wrapper">
            <img src={getImagePath("03")} alt={imageAltTexts?.step3 || "상담 신청"} />
          </div>
        </div>
      )}

      <div className="footer">
        {customFooter && footerData ? (
          <div className="custom-footer">
            <p className="footer-line1">{footerData.line1}</p>
            <p className="footer-line2">{footerData.line2}</p>
            <p className="footer-line3">{footerData.line3}</p>
          </div>
        ) : (
          footerPath && <img src={footerPath} alt="푸터" />
        )}
      </div>
    </div>
  );
}

export default RandingStyle27;
